<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="短剧id 外键{zb_video.id}" prop="videoId">-->
<!--                <a-input v-model="queryParam.videoId" placeholder="请输入短剧id 外键{zb_video.id}" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="短剧封面/活动封面" prop="videoCover">-->
<!--                <a-input v-model="queryParam.videoCover" placeholder="请输入短剧封面/活动封面" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="是否推迟至明天发送" prop="isTomorrow">-->
<!--                <a-select placeholder="请选择是否推迟明天发送" v-model="queryParam.isTomorrow" >-->
<!--                  <a-select-option value="0">否</a-select-option>-->
<!--                  <a-select-option value="1">是</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="发送时间" prop="sendTime">
                <a-date-picker style="width: 100%" v-model="queryParam.sendTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" >
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" >
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['activity:push:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="sendTime" slot-scope="text, record">
          {{ parseTime(record.sendTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>


        <img style="width: 48px;height: 48px;" v-image-preview :src="record.videoCover" slot="videoCover" slot-scope="text, record">
        <img style="width: 48px;height: 48px;" v-image-preview :src="record.videoCoverEn" slot="videoCoverEn" slot-scope="text, record">


        <span slot="isOpen" slot-scope="text, record">
          <a-switch checkedChildren="启用" unCheckedChildren="封禁" v-model="record.isOpen == 0" @change="changeIsOpen($event,record)"/>
        </span>


        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"  />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" >
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" >
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePush,listPush, delPush ,changeIsOpen} from '@/api/activity/push'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Push',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        videoId: null,
        videoCover: null,
        type: null,
        isTomorrow: null,
        sendTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '短剧id 外键{zb_video.id}',
        //   dataIndex: 'videoId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '活动封面',
          dataIndex: 'videoCover',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'videoCover' },
        },
        {
          title: '活动封面英文',
          dataIndex: 'videoCoverEn',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'videoCoverEn' },
        },
        // {
        //   title: '是否推迟至明天发送',
        //   dataIndex: 'isTomorrow',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender: function (value) {
        //     if(value==0){
        //       return '否'
        //     }else if(value==1){
        //       return '是'
        //     }
        //   }
        // },
        {
          title: '发送时间',
          dataIndex: 'sendTime',
          scopedSlots: { customRender: 'sendTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否启用',
          dataIndex: 'isOpen',
          // ellipsis: true,,
          width: '20%',
          align: 'center',
          scopedSlots: { customRender: 'isOpen' }
        },
        {
          title: '跳转链接',
          dataIndex: 'h5Url',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询活动弹框列表 */
    getList () {
      this.loading = true
     pagePush(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        videoId: undefined,
        videoCover: undefined,
        type: undefined,
        isTomorrow: undefined,
        sendTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeIsOpen (e,record) {
      record.isOpen = e ? 0 : 1
      record.isOpen = +record.isOpen
      changeIsOpen({id: record.id, isOpen: record.isOpen}).then(response => {
        this.$message.success(
          '操作成功'
        )
        return  record.isOpen = e ? 0 : 1
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delPush(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('activity/activity-push/export', {
            ...that.queryParam
          }, `活动弹框_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
